'use client';

import type { FC, ReactNode } from 'react';
import { cva } from 'class-variance-authority';

interface FaqSectionProps {
  children: ReactNode;
  accentColor?: 'blue' | 'gold';
}

const faqSectionVariants = cva(
  'mb-8 [&_h3]:text-xl [&_h3]:font-semibold [&_h3]:mb-4 [&_p]:text-white/90 [&_p]:leading-relaxed [&_p]:text-base [&_li]:text-white/90 [&_li]:mb-3 [&_li]:leading-relaxed [&_li]:text-base',
  {
    variants: {
      accentColor: {
        blue: '[&_h3]:text-blue-500 [&_li]:marker:text-blue-500',
        gold: '[&_h3]:text-gold [&_li]:marker:text-gold',
      },
    },
    defaultVariants: {
      accentColor: 'blue',
    },
  },
);

export const FaqSection: FC<FaqSectionProps> = ({ children, accentColor = 'blue' }) => (
  <div className={faqSectionVariants({ accentColor })}>
    {children}
  </div>
);
